import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  OnDestroy,
} from '@angular/core';
import {
  FieldType,
  formsActions,
  FormState,
  ngrxFormsQuery,
  Field,
} from '@switch_software/ui-components';

import { Store } from '@ngrx/store';
import { Validators } from '@angular/forms';
import { of } from 'rxjs';

const structure: Field[] = [
  {
    type: FieldType.TEXT,
    name: 'title',
    label: 'Title',
    placeholder: 'Title',
    validators: [Validators.required],
    errors: [{ type: 'required', message: 'custom required error' }],
  },
  {
    type: FieldType.TEXTAREA,
    name: 'content',
    label: 'Content',
    validators: [Validators.required],
    placeholder: "What's this article about?",
  },
  {
    type: FieldType.SELECT,
    name: 'template',
    label: 'Image Position',
    validators: [Validators.required],
    placeholder: 'Select image position',
    select: {
      options: [
        { id: 1, description: 'Bottom' },
        { id: 2, description: 'Left' },
        { id: 3, description: 'Top' },
        { id: 4, description: 'Top and Bottom' },
      ],
    },
  },
  {
    type: FieldType.CHECK,
    name: 'private',
    label: 'Private article',
  },
  {
    type: FieldType.FILE_UPLOAD,
    name: 'image',
    label: 'Article Image',
    placeholder: 'Only images allowed',
    validators: [Validators.required],
    groupErrors: [
      { type: 'imageQuantityExceeded', message: 'Image quantity exceeded' },
      { type: 'requiredImagesMissing', message: 'Required images missing' },
    ],
    file: {
      accept: 'image/*',
    },
  },
];

@Component({
    selector: 'sbi-cot-back-dynamic-form-smart-example',
    templateUrl: './dynamic-form-smart-example.component.html',
    styleUrls: ['./dynamic-form-smart-example.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class DynamicFormSmartExampleComponent implements OnInit, OnDestroy {
  structure$ = this.store.select(ngrxFormsQuery.selectStructure);
  data$ = this.store.select(ngrxFormsQuery.selectData);
  loading$ = of(false);

  constructor(private store: Store) {}

  ngOnInit() {
    this.store.dispatch(formsActions.setStructure({ structure }));
  }

  onUpdate(state: FormState) {
    this.store.dispatch(formsActions.updateData({ state }));
  }

  onSubmit() {
    console.log('SUBMITTED');
  }

  ngOnDestroy() {
    this.store.dispatch(formsActions.resetForm());
  }
}
